"use client";

import React, { useMemo } from "react";
import { showCaseComponentSwitch } from "@/components/showcase/showcase.utils";

import sortBy from "lodash/sortBy";

const MusicScreen = ({ showcaseData }) => {
  const musicData = useMemo(() => {
    let results = [];

    Object.keys(showcaseData)?.map((key) => {
      showcaseData[key]?.map((item) => results.push(item));
    });

    return sortBy(results, (x) => x.priority);
  }, [showcaseData]);

  return (
    <div className="h-auto min-h-[100vh] w-full pb-24">
      <div className="relative">
        <div className="relative w-full min-h-[150px]">
          {/* <img
            src="/images/music-bg.svg"
            className=" object-cover"
            alt="music"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          /> */}
        </div>
        <div className="w-full relative overflow-visible z-20">
          <div className="absolute left-0 top-[-10vw] right-0 h-[10vw] serial-shadow-alt"></div>
          <div className=" max-w-[1920px] mx-auto">
            <h2 className="font-medium sm:font-bold md:font-extrabold lg:font-black mr-5 sm:mr-11 lg:mr-[5.7rem] text-[#F0F0F0] mb-6 text-3xl md:text-4xl lg:text-5xl z-30 pt-2">
              موسیقی
            </h2>
          </div>
        </div>
      </div>
      <div className="w-full mt-20">
        {musicData?.length > 0 ? (
          <>
            {musicData?.map((item, index) => showCaseComponentSwitch(item, "music", index))}
          </>
        ) : (
          <div className="flex justify-center items-center pt-28">
            <span className="font-extrabold xs:text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#BFBFBF]">
              محتوایی یافت نشد.
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MusicScreen;
